import { render } from "./LibrarySelfService.vue?vue&type=template&id=65089f1b"
import script from "./LibrarySelfService.vue?vue&type=script&lang=js"
export * from "./LibrarySelfService.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__